/**
 * JS other helpers
 */

export const $ = document.querySelector.bind(document);
export const $$ = document.querySelectorAll.bind(document);

// elementsArray :: String, Node -> [Node]|[]
export function elementsArray(selector, element = document) {
    return [].slice.call(element.querySelectorAll(selector));
}

// validateEmail :: String -> Boolean
export function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

// crossStyle :: Element, String, String -> Element
export function crossStyle(element, attribute, value) {
    const attributeU = attribute.charAt(0).toUpperCase() + attribute.slice(1);
    element.style[`webkit${attributeU}`] = value; // Target Webkit
    element.style[`Moz${attributeU}`] = value; // Target Firefox
    element.style[attribute] = value; // Default
    return element;
}

// offset :: Element -> Object
export function offset(el) {
    const rect = el.getBoundingClientRect();
    const scroll = {
        x: window.pageXOffset,
        y: window.pageYOffset,
    };
    return {
        top: rect.top + scroll.y,
        left: rect.left + scroll.x,
        right: rect.right + scroll.x,
        bottom: rect.bottom + scroll.y,
    };
}

// isTouch :: Number -> _ -> Boolean
export const isTouch = (breakpoint = 1200) => () => window.innerWidth < breakpoint;
